import { useEffect, useState } from "react";
import { json, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Cookie from "universal-cookie";
import { httpConfig } from "./httpConfig";
import { ProtectedLogin } from "./protectedlogin";
import { RequestFetch } from "./config/requestFetch";
import moment from "moment";
import { Addmetatags } from "./config/addmetatags";
import { decodeToken } from "react-jwt";

//หน้าล็อคอิน
const Login_page = (props) => {
  const location = useLocation();
  //ตัวแปร
  const navigat = useNavigate();

  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [thisaPin, setThisaPin] = useState([]);
  const cookies = new Cookie();
  const http = httpConfig();

  // ฟังชั่นจัดการหน้าจอเต็มหน้าจอ
  function handleFullScreen() {
    let elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    }
  }

  function handleSummit(event) {
    event.preventDefault();
    console.log("username|password", username, password);
    getInfoUser(`${http}/advisorUser/`);
  }

  //ดึงข้อมูลตาราง user
  function getInfoUser(url) {
    fetch(`${http}/login`, RequestFetch("POST", { pin: password }))
      .then((res) => {
        if (res.ok) {
          res.json().then((data) => {
            // console.log("ข้อมูล tokenis >>", decodeToken(data.token));
            // try to subString token with set on Cookiesession
            // let shortendToken = data.token.substring(0, 20) + "...";
            // let valuesettoken = `SHORTENED:${shortendToken}`;

            // console.log("for SET onCookie", valuesettoken);

            // if (valuesettoken.startsWith(`SHORTENED`)) {
            //   let tryshortend = valuesettoken.substring(`SHORTENED:`.length);

            //   console.log("for USER token is >>>>", tryshortend);
            // }

            const oneyearformnow = new Date();
            oneyearformnow.setFullYear(oneyearformnow.getFullYear() + 1);

            // console.log("check", data);
            cookies.set("tokenEstimate", data.token, {
              // secure: true,
              path: "/",
              // maxAge: 60 * 60 * 24 * 365,
              expires: oneyearformnow,
            });

            let loop = 0;
            while (loop <= 5) {
              document.getElementById(`circlefill-${loop}`).style.display =
                "none";
              document.getElementById(`circle-${loop}`).style.display =
                "inline-block";
              loop++;
            }
            setThisaPin("");
            switch (data.adv_group) {
              case 1:
                ProtectedLogin(2).then((res) => {
                  if (res) {
                    // console.log("เข้าไปเลยไอ่เสือ");
                    // fetch(
                    //   `${httpConfig()}/proxyLineNotify`,
                    //   RequestFetch("POST", {
                    //     grptoken: "H7XB8a4YTbHjuLob0a7y5WYdh8o9ck2e1XrnFGNC66U",
                    //     messagesend: `ผู้ใช้งาน ${
                    //       decodeToken(data.token).username
                    //     } เข้าสู่ระบบประเมินนักศึกษาแพทย์ Estimate`,
                    //   })
                    // )
                    //   .then((res) => {
                    //     if (res.status === 200) {
                    //       res.json().then((data) => {
                    //         console.log("data proxyLineNotify", data);
                    //       });
                    //     }
                    //   })
                    //   .catch((err) => {
                    //     console.error("notify_line error >>", err);
                    //   });
                    navigat(`/listwork?timestamp=${new Date().getTime()}`);
                  }
                });
                break;
              case 2:
                ProtectedLogin(1).then((res) => {
                  if (res) {
                    // console.log("เข้าไปยังของ Resident");
                    navigat("/resident_home");
                  }
                });
                break;
              default:
                break;
            }
          });
        } else {
          console.log("error");
          let loop = 0;
          while (loop <= 5) {
            document.getElementById(`circlefill-${loop}`).style.display =
              "none";
            document.getElementById(`circle-${loop}`).style.display =
              "inline-block";
            loop++;
          }
          setThisaPin("");
          return Swal.fire({
            icon: "warning",
            title: "เข้าสู่ระบบล้มเหลว",
            text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง",
            confirmButtonColor: "#396a8d",
            confirmButtonText: "ตกลง",
          });
        }
      })
      .catch((err) => {
        console.error("login fail", err);
      });

    // fetch(url, requestOption).then((res) =>
    //   res.json().then((data) => {
    //     if (!data[0]) {
    //       let loop = 0;
    //       while (loop <= 5) {
    //         document.getElementById(`circlefill-${loop}`).style.display =
    //           "none";
    //         document.getElementById(`circle-${loop}`).style.display =
    //           "inline-block";
    //         loop++;
    //       }
    //       setThisaPin("");
    //       return Swal.fire({
    //         icon: "warning",
    //         title: "เข้าสู่ระบบล้มเหลว",
    //         text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง",
    //         confirmButtonColor: "#396a8d",
    //         confirmButtonText: "ตกลง",
    //       });
    //     }

    //     // console.log(data);
    //     data.map((data) => {
    //       // console.log("ข้อมูลของ", data.name);
    //       localStorage.setItem(
    //         "advisor",
    //         JSON.stringify({
    //           advisor_id: data.Id,
    //           advisor_title: data.ttl,
    //           advisor_name: data.name,
    //           advisor_lname: data.lname,
    //           gender: data.sex,
    //           advisor_start: data.start,
    //           advisor_stop: data.stop,
    //         })
    //       );
    //       // console.log(
    //       //   "ก่อนจะเข้ารหัส เช็ตโทเคน >>> ",
    //       //   data.adv_id.trim(),
    //       //   "!!",
    //       //   data.pin.trim()
    //       // );
    //       let encodeBase64 = window.btoa(
    //         `${data.adv_id.trim()}|${data.pin.trim()}`
    //       );

    //       cookies.set("tokenEstimate", encodeBase64, {
    //         path: "/",
    //         maxAge: 3600, //3600
    //       });
    //       // handleFullScreen();

    //       // trySocket connecting
    //       // const ws = new WebSocket("ws://localhost:8888");
    //       // ws.addEventListener("open", () => {
    //       //   console.log("this connected");

    //       //   ws.send(data.name);
    //       // });

    //       // ws.addEventListener("message", (event) => {
    //       //   console.log(event.data);
    //       // });

    //       navigat("/listWork");
    //     });
    //     // if (data[0].username) {
    //     //   let encodeBase64 = btoa(
    //     //     `${data[0].username}|${data[0].password}|${data[0].permission}`
    //     //   );

    //     //   cookies.set("userCookie", encodeBase64, {
    //     //     path: "/",
    //     //     maxAge: 3600,
    //     //   });
    //     //   handleFullScreen();
    //     //   navigat("/homepage");
    //     // }
    //   })
    // );
  }

  // ฟังชั่น เมื่อกดลบ pin
  function handleDeletePin() {
    let arr = thisaPin;
    let arrlenght = thisaPin.length - 1;
    arr.pop();
    setThisaPin(arr);
    console.log(arrlenght);
    document.getElementById(`circle-${arrlenght}`).style.display =
      "inline-block";
    document.getElementById(`circlefill-${arrlenght}`).style.display = "none";
  }

  function handlecheckLoginAuto() {
    if (!cookies.get("tokenEstimate")) return;
    let token = atob(cookies.get("tokenEstimate"));
    let requestDatatoken = {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ pinadvisor: token.split("|")[1] }),
    };
    fetch(`${http}/advisorUser`, requestDatatoken).then((res) =>
      res.json().then((data) => {
        console.log(":)", data);
        data.map((data) => {
          localStorage.setItem(
            "advisor",
            JSON.stringify({
              advisor_id: data.Id,
              advisor_title: data.ttl,
              advisor_name: data.name,
              advisor_lname: data.lname,
              gender: data.sex,
              advisor_start: data.start,
              advisor_stop: data.stop,
            })
          );
        });
        navigat(`/listwork?timestamp=${new Date().getTime()}`);
      })
    );
  }

  //ล๊อคคีดาว เปิด devtool
  // window.addEventListener("keydown", function (e) {
  //   if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key === "I")) {
  //     e.preventDefault();
  //   }
  // });

  useEffect(() => {
    Addmetatags();
    // console.log("advisor_ID ==>", props.IdAdvisor);
    if (!props.IdAdvisor || !props.PinAdvisor) {
      navigat("/");
    }
    // ProtectedLogin().then((status) => {
    //   if (status) {
    //     console.log("เข้าระบบอีกครั้งเพราะยังมีตัว Token ");
    //     navigat("/listwork");
    //   }
    // });
  }, [location.search]);

  useEffect(() => {
    if (thisaPin) {
      //เมื่อมีpin
      // console.log("!!!=>", thisaPin);
      let domID = (id) => {
        return document.getElementById(id);
      };

      let stringPIN = "";
      thisaPin.map((data, index) => {
        if (!stringPIN || stringPIN === "") {
          stringPIN = data.toString();
        } else {
          stringPIN = stringPIN.toString() + data.toString();
        }
        domID(`circle-${index}`).style.display = "none";
        domID(`circlefill-${index}`).style.display = "inline-block";
      });

      // console.log("stringPIN = >", stringPIN);
      setPassword(stringPIN);
    }
  }, [thisaPin]);

  useEffect(() => {
    if (!password) return;
    if (password.length === 6) {
      //เมื่อ password ครบ 6 ตัว
      console.log("!oing :) ");
      // getInfoUser(`${http}/advisorUser`);
      if (props.PinAdvisor.toString().trim() === password.toString().trim()) {
        getInfoUser(`${http}/advisorUser`);
      } else {
        Swal.fire({
          icon: "warning",
          title: "รหัส PIN ผิดลาด !!",
          text: "กรุณาเข้าสู่ระบบใหม่อีกครั้ง !!!",
          showConfirmButton: false,
          showCancelButton: false,
          timer: 1800,
        });
        navigat("/");
      }
    }
  }, [password]);

  return (
    <div className="Login_box">
      <div className="content-loginbody">
        <div className="header-login">
          <h1>เข้าสู่ระบบ</h1>
        </div>
        <div className="show-pin-login">
          <div className="icon-show-pinlogin">
            <i className="bi-circle" id="circle-0"></i>
            <i className="bi-circle-fill" id="circlefill-0"></i>
            <i className="bi-circle" id="circle-1"></i>
            <i className="bi-circle-fill" id="circlefill-1"></i>
            <i className="bi-circle" id="circle-2"></i>
            <i className="bi-circle-fill" id="circlefill-2"></i>
            <i className="bi-circle" id="circle-3"></i>
            <i className="bi-circle-fill" id="circlefill-3"></i>
            <i className="bi-circle" id="circle-4"></i>
            <i className="bi-circle-fill" id="circlefill-4"></i>
            <i className="bi-circle" id="circle-5"></i>
            <i className="bi-circle-fill" id="circlefill-5"></i>
          </div>
        </div>
        <div className="box-pin-login">
          <div className="number-pin-login">
            <div
              className="btn-pin-number"
              onClick={() => {
                if (thisaPin.length <= 5) {
                  setThisaPin([...thisaPin, "1"]);
                }
              }}
            >
              <p className="icon-btn-login">1</p>
            </div>
            <div
              className="btn-pin-number"
              onClick={() => {
                if (thisaPin.length <= 5) {
                  setThisaPin([...thisaPin, "2"]);
                }
              }}
            >
              <p className="icon-btn-login">2</p>
            </div>
            <div
              className="btn-pin-number"
              onClick={() => {
                if (thisaPin.length <= 5) {
                  setThisaPin([...thisaPin, "3"]);
                }
              }}
            >
              <p className="icon-btn-login">3</p>
            </div>
            <div
              className="btn-pin-number"
              onClick={() => {
                if (thisaPin.length <= 5) {
                  setThisaPin([...thisaPin, "4"]);
                }
              }}
            >
              <p className="icon-btn-login">4</p>
            </div>
            <div
              className="btn-pin-number"
              onClick={() => {
                if (thisaPin.length <= 5) {
                  setThisaPin([...thisaPin, "5"]);
                }
              }}
            >
              <p className="icon-btn-login">5</p>
            </div>
            <div
              className="btn-pin-number"
              onClick={() => {
                if (thisaPin.length <= 5) {
                  setThisaPin([...thisaPin, "6"]);
                }
              }}
            >
              <p className="icon-btn-login">6</p>
            </div>
            <div
              className="btn-pin-number"
              onClick={() => {
                if (thisaPin.length <= 5) {
                  setThisaPin([...thisaPin, "7"]);
                }
              }}
            >
              <p className="icon-btn-login">7</p>
            </div>
            <div
              className="btn-pin-number"
              onClick={() => {
                if (thisaPin.length <= 5) {
                  setThisaPin([...thisaPin, "8"]);
                }
              }}
            >
              <p className="icon-btn-login">8</p>
            </div>
            <div
              className="btn-pin-number"
              onClick={() => {
                if (thisaPin.length <= 5) {
                  setThisaPin([...thisaPin, "9"]);
                }
              }}
            >
              <p className="icon-btn-login">9</p>
            </div>
            <div className="btn-pin-number" style={{ visibility: "hidden" }}>
              <i className="bi-x-lg"></i>
            </div>
            <div className="btn-pin-number">
              <p
                className="icon-btn-login"
                onClick={() => {
                  if (thisaPin.length <= 5) {
                    setThisaPin([...thisaPin, "0"]);
                  }
                }}
              >
                0
              </p>
            </div>
            <div
              className="btn-pin-number"
              onClick={() => {
                console.log("Delete pin");
                handleDeletePin();
              }}
              // style={{ visibility: "hidden" }}
            >
              <div className="icon-btn-pinnumber">
                <i className="bi-arrow-left"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login_page;
